module.exports = ["همین حالا",["%s ثانیه پیش","%s ثانیه پیش"],["%s دقیقه پیش","%s دقیقه پیش"],["%s ساعت پیش","%s ساعت پیش"],["%s روز پیش","%s روز پیش"],["%s هفته پیش","%s هفته پیش"],["%s ماه پیش","%s ماه پیش"],["%s سال پیش","%s سال پیش"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/fa-IR.json
// module id = n1qB
// module chunks = 1